(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("inviteToApplyDataService", inviteToApplyDataService);

    inviteToApplyDataService.$inject = ['$q', 'CreditsAPI'];

    function inviteToApplyDataService($q, CreditsAPI) {

        var self = this;
        var _emitter = JarEventEmitter.call(self);
        var brandsBalance = {};

        var EVENTS = {
            ON_INVITE_TO_APPLY_SEND_AFTER: "ON_INVITE_TO_APPLY_SEND_AFTER",
        };

        self.onInviteToApplySendAfter = function (callBack) {
            return self.on(EVENTS.ON_INVITE_TO_APPLY_SEND_AFTER, callBack);
        };

        self.sendJobApplyInvitationToCandidates = function (jobId, candidateIds, subject, message, brandId, source) {
            var deferred = $q.defer();

            BrandAPI.sendJobApplyInvitation(jobId, candidateIds, subject, message, brandId, source)
                .then(function (data) {
                    _emitter.trigger(EVENTS.ON_INVITE_TO_APPLY_SEND_AFTER, jobId, candidateIds, subject, message, data);
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getBrandBalance = function (brandId) {
            var deferred = $q.defer();

            if (brandsBalance[brandId]) {
                deferred.resolve(brandsBalance[brandId]);
            } else {
                CreditsAPI.getBrandBalance(brandId)
                    .then(function (resp) {
                        if (resp && resp.data && resp.data.data && resp.data.status_code === 200) {
                            brandsBalance[brandId] = resp.data.data;
                            deferred.resolve(resp.data.data);
                        } else {
                            deferred.reject(resp);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }
            return deferred.promise;
        };

        self.getBrandMessageTemplates = function (brandId, filter, category) {
            var deferred = $q.defer();

            BrandAPI.getBrandMessageTemplates(brandId, filter, category)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getTemplateSmartFields = function (category) {
            var deferred = $q.defer();

            BrandAPI.getTemplateSmartFields(category)
                .then(function (smartFields) {
                    smartFields = smartFields.map(function (item) {
                        item.name = $filter("translate")(item.name);
                        return item;
                    });
                    deferred.resolve(smartFields);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getSystemInviteToApplyTemplates = function () {
            var deferred = $q.defer();

            BrandAPI.getSystemInviteToApplyTemplates()
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getCandidateInvitesToApply = function (groupId, candidateId) {

            var deferred = $q.defer();

            MemberAPI.getMemberInvitesToApply(groupId, candidateId)
                .then(function (res) {
                    for (var i in res.job_invites) {
                        if (res.job_invites[i].status === "unseen" || res.job_invites[i].status === "seen") {
                            res.job_invites[i].displayStatus = $filter("translate")("invited");
                        } else {
                            res.job_invites[i].displayStatus = res.job_invites[i].status;
                        }
                    }
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        return self;
    }
}());
